import { SelectInput } from '@interstate/components/SelectInput';
import { useMilesPerYearField } from '@makemydeal/dr-dash-components';

import { useScenarioCellId } from '../../../hooks/useScenarioCellId';
import { ScenarioRow } from '../../ScenarioRow';

export const MilesPerYearRow = () => {
    const { label, selectProps } = useMilesPerYearField({ isSummaryTab: true });
    const inputId = useScenarioCellId('annualMiles');

    return (
        <ScenarioRow rowKey="annualMiles" label={label} inputId={inputId}>
            <SelectInput {...selectProps} id={inputId} label={label} displayLabel={false} />
        </ScenarioRow>
    );
};
